import { render } from "./App.vue?vue&type=template&id=970ad36a&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=970ad36a&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-970ad36a"]])

export default __exports__